export const TOKEN = 'token';
export const SIGN = 'sign';
export const REFRESH_TOKEN = 'refresh_token';
export const EDU_URL = '.wukongedu.net';
export const SCH_URL = '.wukongsch.com';
export const LAST_REFRESH_TIME = 'last_refresh_time';
export const NEED_REFRESH_TOKEN_DAY = 15;
export const TOKEN_VALID_DAY = 30;
export const USER_ID = 'userId';
export const USER_EMAIL = 'user_email';
export const SIMP_OFFICIAL_WEBSITE_EDU_URL = `https://www-intl.wukongedu.net`;
export const SIMP_OFFICIAL_WEBSITE_URL = `https://www.wukongsch.com`;
export const STU_WEBSITE_URL = `https://student.wukongedu.net`;
export const MOBILE_REG = '.*iPhone|Android|SymbianOS|Windows Phone|iPod{1,}.*';
export const REGEXP_EMAIL = /^[^@]{1,}@[^@]{1,}$/;
export const STATIC_RESOURCES_REG =
  /\.(js|css|png|jpg|jpeg|gif|svg|ico|woff|woff2|ttf|eot|map|json|xml|txt|pdf|zip|rar|mp4|mp3|avi|mov|wmv|flv|webm|webp|bmp|tiff|html)$/i;

/* 旧学员中心页面路径 */
export const OLD_STU_CENTER_PATHS = [
  '/agreement',
  '/app/about',
  '/app/classProcess',
  '/app/courseConsumeInfo',
  '/app/courseFeatures',
  '/app/courseGuidance',
  '/app/expirationList',
  '/app/season-confirm',
  '/app/travel-to-china',
  '/app/timeTip',
  '/app-middle-page',
  '/auth',
  '/calendar-middle-page',
  '/cancel-course',
  '/contestClass',
  '/custom-block/button',
  '/custom-block/card',
  '/customerService',
  '/device-middle-page',
  '/family',
  '/home/ai/lesson',
  '/home/ai/list',
  '/home/aiNew/list',
  '/home/appointment/english',
  '/home/appointment/result',
  '/home/appointment/result_bak',
  '/home/bindPhone',
  '/home/bookClass',
  '/home/bookClass/private',
  '/home/cashier-desk/aw/aw-add-params',
  '/home/cashier-desk/aw/middle',
  '/home/cashier-desk/aw/out-of-wechat',
  '/home/cashier-desk/bankTransfer',
  '/home/cashier-desk/bankTransfer/images',
  '/home/cashier-desk/installment',
  '/home/cashier-desk/middle',
  '/home/cashier-desk/result',
  '/home/cashier-desk/resultNoAuth',
  '/home/cashier-desk/[page]',
  '/home/close-account',
  '/home/cognia-certificate',
  '/home/coursePackage/info',
  '/home/coursePackage/list',
  '/home/downloadPage',
  '/home/iexercise',
  '/home/independent-appointment',
  '/home/leave',
  '/home/lesson/playback',
  '/home/lesson/task',
  '/home/orderCenter',
  '/home/orderInfo',
  '/home/period/detail',
  '/home/period',
  '/home/profile',
  '/home/renewalCourses',
  '/home/result',
  '/home/self-service-rescheduling',
  '/home/selfServiceLeave',
  '/home/share',
  '/home/subscription',
  '/home/subscription/info',
  '/home/subscription/plan',
  '/home/subscription/plan/[page]',
  '/home/subscriptionDetails',
  '/home/subscriptionPreview',
  '/home/[page]/subscriptionPreview',
  '/home/train/adjust',
  '/home/train/cache',
  '/home/train/finished',
  '/home/train/order',
  '/home/vouchers',
  '/howClass',
  '/intercom',
  '/introduce',
  '/learningProgress/center',
  '/login/bind',
  '/login',
  '/m/bookClass/private',
  '/m/bookClass',
  '/m/cancel-course',
  '/m/cognia-certificate',
  '/m/courseGuidance',
  '/m/home/appointment/result',
  '/m/home/bookClass/private',
  '/m/home/bookClass',
  '/m/home/class-tutorial',
  '/m/home/renewalCourses',
  '/m/home/subscriptionDetails',
  '/m/home/train/finished',
  '/m/home/train/order',
  '/m/home/train/reserve',
  '/m/home',
  '/m/learningProgress/center',
  '/m/learningProgress/center/learningCenter',
  '/m/learningProgress/unit',
  '/m/login',
  '/m/reserve/chinese',
  '/m/reserve',
  '/m/retrieve-password',
  '/m/self-service-rescheduling/Content',
  '/m/self-service-rescheduling',
  '/m/selfServiceLeave',
  '/message',
  '/my-course',
  '/new-introduce',
  '/notice/now',
  '/notice',
  '/notification/adjustTeacher',
  '/notification/cancelSchedule',
  '/parentVerification',
  '/project',
  '/r',
  '/remark/result',
  '/remark',
  '/reserve/chinese',
  '/reserve',
  '/selectCourseEntry',
  '/trial-study-report',
  '/video',
  '/whatsApp',
] as const;

/* 需要添加/m/前缀的路径 */
export const NEED_ADD_M_PATHS = [
  '/home',
  // '/home/appointment/result',
  // '/home/subscriptionDetails',
  // '/home/renewalCourses',
  // '/learningProgress/center',
] as const;

/* 不需要登录权限的路径（所有设备） */
export const NO_AUTH_PATHS = ['/login/wechat-login'];

/* 仅移动端不需要登录权限的路径 */
export const MOBILE_ONLY_NO_AUTH_PATHS = [
  '/rewards/mall',
  '/rewards/mall/commodity-details',
  '/rewards/mall/rules',
];

export const EMAIL_LENGTH = 50;
export const POST_MESSAGE_ID = 'd3Vrb25nbXNn';
export const REGEXP_PHONE = /^\d+$/;
export const REGEXP_PASSWORD = /^\S*(?=\S{8,})(?=\S*\d)(?=\S*[a-z])\S*$/;
export const TEST_DEVICE_RESULT = 'TEST_DEVICE_RESULT';

/* 不需要显示Intercom的路径 */
export const HIDE_INTERCOM_PATHS = [
  'app_android',
  'app_ios',
  'custom-block',
  'new-introduce',
  'courseconsumeinfo',
  'remark',
  'notification/adjustteacher',
  'notification/cancelschedule',
  'wechat-login',
  'trial-study-report',
  'select-course-component',
  'iexercise',
  'travel-to-china',
  '/choose-course',
  '/cloud-storytelling-session',
  '/expand-subject',
];

/* 不需要显示Kaamel的路径 */
export const HIDE_KAAMEL_PATHS = [
  '/introduce',
  '/new-introduce',
  '/auth',
  '/home/bindPhone',
  '/agreement',
  '/notice',
  '/project',
  '/app/timeTip',
  '/app/about',
  '/app/expirationList',
  '/app/courseConsumeInfo',
  '/app/courseFeatures',
  '/m/home',
  '/app/classProcess',
  '/remark',
  '/m/bookClass',
  '/m/bookClass/private',
  '/m/home/bookClass',
  '/m/home/bookClass/private',
  '/home/bookClass',
  '/home/bookClass/private',
  '/m/learningProgress/center',
  '/app/season-confirm',
  '/notification',
  '/trial-study-report',
  '/m/selfServiceLeave',
  '/selectCourseEntry',
  '/app-middle-page',
  '/m/self-service-rescheduling',
  '/r',
  '/calendar-middle-page',
  '/m/cancel-course',
  '/custom-block/button',
  '/custom-block/card',
  '/home/cashier-desk',
  '/home/subscriptionPreview',
  '/choose-course',
  '/cloud-storytelling-session',
  '/expand-subject',
];

/* 旧学员中心路径重定向到新路径（这部分功能迁移到了新学员中心了） */
export const OLD_PATH_REDIRECT_PATHS = {
  '/home/cognia-certificate': '/account/cognia',
  '/cognia-certificate': '/account/cognia',
  '/home/profile': '/account/profile',
  '/home/period': '/account/course-credits',
  '/home/vouchers': '/account/my-vourchers',
  '/home/orderCenter': '/account/my-orders?type=regular',
  '/home/subscription': '/account/my-orders?type=subscription',
  '/home/leave': '/account/leave',
  '/home/lesson': '/study/schedule',
  '/home/lesson/task': '/study/homework',
  '/home/share': '/home',
  '/study': '/study/schedule',
  '/account': '/account/course-credits',
};

/* 需要显示版本切换按钮的路径 */
export const SHOW_SWITCH_VERSION_PATHS = [
  '/home',
  '/study/schedule',
  '/study/homework',
  '/account/course-credits',
  '/account/leave',
  '/account/cognia',
  '/account/my-orders',
  '/account/my-vourchers',
  '/account/account',
  '/account/profile',
  '/account/terms',
  '/account',
  '/study',
];

/* 新版本切换到旧版本后映射的路径 */
export const NEW_VERSION_TO_OLD_VERSION_PATHS = {
  '/study/schedule': '/home/lesson',
  '/study/homework': '/home/lesson/task',
  '/account/cognia': '/home/cognia-certificate',
};

export const CLASS_IN_URL = 'https://www.eeo.cn/client/invoke/index.html';

export const cdnDomain = 'https://cdnwukong.com';
